<template>
  <v-container fluid>
    <v-layout
      align-center
      justify-center
    >
      <v-flex xs12>
        <v-card>
          <v-toolbar
            dark
            color="primary"
            dense
          >
            <v-toolbar-title class="headline">Now scoring: {{teamAnswers.heading}}</v-toolbar-title>
          </v-toolbar>
          <v-layout
            align-start
            justify-center
          >
            <v-flex
              xs4
              class="pa-3"
            >
              <v-card class="elevation-12">
                <v-toolbar dark>
                  <v-toolbar-title class="text-xs-center">Team Answers</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn v-if="!fetchingTeams" icon @click="refreshTeams">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                  <v-progress-circular
                    indeterminate
                    color="white"
                    v-else
                    ></v-progress-circular>
                </v-toolbar>
                <v-list subheader>
                  <v-list-tile
                    v-for="team in teamAnswers.teamAnswers"
                    v-bind:key="team.teamId"
                    avatar
                    @click="showTeamAnswers(team.teamId, team.name)"
                  >
                    <v-list-tile-avatar>
                      <v-icon
                        v-show="scoredTeamIds.includes(team.teamId)"
                        color="green"
                      >check</v-icon>
                      <v-icon>group</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{team.name}}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-icon v-show="team.teamId === selectedTeamId">arrow_forward</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
            <v-flex
              xs8
              class="pa-3"
            >
              <div class="text-xs-center mb-4">
                <div class=" headline">{{teamAnswers.body}}</div>
              </div>
              <v-card>
                <v-card-text>
                  <div v-if="teamsHaveAnswered">
                    <div class="title">Team: {{selectedName}}</div>
                    <v-list>
                      <v-list-tile
                        v-for="segment in selectedTeamAnswers.segments"
                        :key="segment.text"
                        class="ma-1"
                      >
                        <v-list-tile-content class="ml-4">
                          <v-list-tile-title>
                            <div v-if="segment.teamAnswerId">
                              {{selectedName}}'s answer:
                              <span :class="[segment.submittedAnswerText && getAcceptedAnswersString(segment.acceptedAnswers).toLowerCase().includes(segment.submittedAnswerText.toLowerCase()) ? 'green--text':'red--text']">
                                {{segment.submittedAnswerText ? segment.submittedAnswerText : "Left Blank"}}
                              </span>
                            </div>
                            <div v-else>
                              The team didn't provide an answer for this segment
                            </div>
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            Correct {{segment.text}} =
                            <span class="green--text">
                              {{getAcceptedAnswersString(segment.acceptedAnswers)}}
                            </span>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-tooltip bottom>
                          <v-btn
                            slot="activator"
                            color="green"
                            fab
                            small
                            dark
                            class="mr-3"
                            @click="segment.earnedPoints = segment.pointsValue"
                          >
                            <v-icon>library_add</v-icon>
                          </v-btn>
                          <span>Award Max Points</span>
                        </v-tooltip>

                        <v-text-field
                          v-model="segment.earnedPoints"
                          label="Earned Points"
                          type="number"
                        ></v-text-field> <span class="ml-4">out of {{segment.pointsValue}} total possible</span>
                      </v-list-tile>
                    </v-list>
                    <v-btn
                      color="secondary"
                      @click="saveScores"
                      class="mt-5"
                    >
                      <v-icon left>save</v-icon>
                      Submit Scores
                    </v-btn>
                    <div v-show="scoredTeamIds.includes(selectedTeamId)" class="green--text">
                      <v-icon
                        color="green"
                      >check</v-icon>
                      Scores are saved but you can update at any time
                    </div>
                  </div>
                  <div v-else>No teams have submitted an answer yet</div>
                </v-card-text>
              </v-card>
              <v-form ref="form"></v-form>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import GameModel from "../../api/game-model";

export default {
  name: "ScoreTeamAnswers",
  props: ["gameOccurrenceId", "questionId"],
  data() {
    return {
      hostConnected: false,
      selectedTeamId: 0,
      selectedName: "",
      selectedTeamAnswers: {},
      teamsHaveAnswered: false,
      scoredTeamIds: [],
      fetchingTeams: false
    };
  },
  methods: {
    ...mapActions("host", ["getTeamAnswers", "saveTeamAnswerScores"]),
    showTeamAnswers(teamId, teamName) {
      this.selectedTeamId = teamId;
      this.selectedName = teamName;
      this.selectedTeamAnswers = this.teamAnswers.teamAnswers.find(
        s => s.teamId === teamId
      ).scoredQuestions[0];
    },
    async saveScores() {
      let teamScores = {
        teamId: this.selectedTeamId,
        scores: this.selectedTeamAnswers.segments.map(s => {
          return {
            questionSegmentId: s.questionSegmentId,
            earnedPoints: parseInt(s.earnedPoints)
          };
        })
      };
      await this.saveTeamAnswerScores({
        gameOccurrenceId: this.gameOccurrenceId,
        teamScores: teamScores
      });
      this.scoredTeamIds.push(this.selectedTeamId);
    },
    getAcceptedAnswersString(acceptedAnswers) {
      let acceptedAnswersString = "";
      for (var i = 0; i < acceptedAnswers.length; i++) {
        acceptedAnswersString += acceptedAnswers[i];
        if (i != acceptedAnswers.length - 1) {
          acceptedAnswersString += " OR ";
        }
      }
      return acceptedAnswersString;
    },
    async refreshTeams(){
        this.fetchingTeams = true;
        await this.getTeamAnswers({
      gameOccurrenceId: this.gameOccurrenceId,
      questionId: this.questionId
    }).catch(e => alert("Bummer, refreshing teams failed... " + e.message));
     this.fetchingTeams = false;
    }
  },
  computed: {
    ...mapState("host", {
      apiMessage: state => state.apiMessage,
      teamAnswers: state => state.teamAnswers
    }),
    ...mapGetters("admin", {
      adminToken: "token"
    })
  },
  watch: {
    async teamAnswers(ta) {
      if (ta.teamAnswers.length >= 1) {
        this.teamsHaveAnswered = true;
        this.showTeamAnswers(ta.teamAnswers[0].teamId, ta.teamAnswers[0].name);
      }
    }
  },
  async created() {
    await this.getTeamAnswers({
      gameOccurrenceId: this.gameOccurrenceId,
      questionId: this.questionId
    }).catch(e => alert("Bummer, loading teams failed... " + e.message));
    this.hostConnected = true;
  }
};
</script>